export default __webpack_public_path__ + "media/color/clam-aa8a8b04.svg";